import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const match = location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    if (!sessionId) { navigate("/login", { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google", { session_id: sessionId });
        if (data.token) localStorage.setItem("cz_token", data.token);
        window.history.replaceState({}, document.title, "/inbox");
        await refresh();
        navigate("/inbox", { replace: true });
      } catch (e) {
        toast.error(e.response?.data?.detail || "Falha no login Google");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background gap-3">
      <Loader2 className="w-8 h-8 animate-spin text-emerald-600" />
      <div className="text-sm text-muted-foreground">Autenticando com Google…</div>
    </div>
  );
}
